import { Link } from 'react-router-dom';

import logo from './../assets/images/schoolhack-logo.png';

const REGISTER_URL = 'https://app.schoolhack.ai/auth/register';

const COLUMNS = [
  {
    title: 'Features',
    links: [
      { name: 'Interactive Note', to: '/features/interactive-notes' },
      { name: 'Interactive Quizzes', to: '/features/interactive-quizzes' },
      { name: 'Interactive Flashcards', to: '/features/interactive-flashcards' },
      { name: 'Interactive Teacher', to: '/features/interactive-teacher' },
      { name: 'Collaborative Mode', to: '/features/collaborative-mode' },
    ],
  },
  {
    title: 'Company',
    links: [
      { name: 'About Us', to: '/about-us' },
      // { name: 'Careers', to: '/career' },
      { name: 'Blog', to: '/blogs' },
      { name: 'Contact Us', to: '/contactus' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { name: 'Terms & Conditions', to: '/terms-condition' },
      { name: 'Privacy Policy', to: '/privacy-policy' },
    ],
  },
];

const linkClass = 'text-[0.9rem] text-white/50 transition-colors hover:text-accent';

const Footer = () => {
  return (
    <footer className="relative px-4 pb-12 md:px-6">
      <div className="card-dark mx-auto max-w-[80rem] overflow-hidden rounded-[1.75rem] border border-white/8 p-8 md:p-12">
        <div className="grid gap-10 lg:grid-cols-[1.6fr_1fr_1fr_1fr]">
          {/* brand */}
          <div className="max-w-xs">
            <Link to="/" className="flex items-center">
              <img src={logo} alt="School Hack" className="h-8 w-auto" />
            </Link>
            <p className="mt-5 text-[0.9rem] leading-relaxed text-white/50">
              SchoolHack is a free educational platform used by students across
              the globe. Sign up to School Hack, and start studying now.
            </p>
            <a
              href={REGISTER_URL}
              target="_blank"
              rel="noreferrer"
              className="btn-primary mt-6 px-5 py-3 text-[0.9rem]"
            >
              Sign up for free
            </a>
          </div>

          {/* link columns */}
          {COLUMNS.map((col) => (
            <div key={col.title}>
              <h4 className="font-heading mb-4 text-[0.95rem] font-semibold text-white">
                {col.title}
              </h4>
              <ul className="flex flex-col gap-3">
                {col.links.map((l) => (
                  <li key={l.name}>
                    {l.external ? (
                      <a href={l.href} target="_blank" rel="noreferrer" className={linkClass}>
                        {l.name}
                      </a>
                    ) : (
                      <Link to={l.to} className={linkClass}>
                        {l.name}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
